import { render, staticRenderFns } from "./SortFilter.vue?vue&type=template&id=24ee1be1&scoped=true"
import script from "./SortFilter.vue?vue&type=script&lang=js"
export * from "./SortFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee1be1",
  null
  
)

export default component.exports